module.exports = __webpack_public_path__ + "static/media/hamburger.7c781bca.svg";